(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
    class SearchBlogs extends HTMLElement {
        constructor() {
            super();
            this.input = this.querySelector("#blog-search");
            this.results = [];
            this.articlesContainter = document.querySelector("[data-articles]");
            this.resultsContainter = document.querySelector("[data-results]");

        }
				connectedCallback() {
            this.input.addEventListener('input', this.debounce((event) => {
              this.onChange(event);
            }, 500).bind(this));
				}
        onChange() {
            const searchTerm = this.input.value.trim();
            if (searchTerm.length) {
            fetch(`/search?q=${encodeURIComponent(searchTerm)}&view=blogs&type=article`, {
                method: 'GET',
                })
                .then((response) => response.json())
                .then((parsedState) => {
                    this.results = parsedState.results
                    this.setResults();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }else{
              this.articlesContainter.classList.remove("hidden");
              this.resultsContainter.classList.add("hidden");
            }

        }
        setResults(){
          if(this.results.length > 0){
            let html = "";
            for (let i = 0; i < this.results.length; i++) {
               const item = this.results[i];
               html += ` <div class="blog-articles__article article shadow-xl"  ><div class="card-wrapper underline-links-hover">
                  <div class="card article-card relative card-- article-card__image--medium card--media"
                    style="--ratio-percent: 66.650390625%;">
                    <div class="card__inner flex relative items-stretch grid grid-rows-1 {% if settings.card_style == 'standard' %} color-{{ settings.card_color_scheme }}{% endif %}{% if article.image and show_image or settings.card_style == 'standard' %} ratio{% endif %}" style="--ratio-percent: {{ 1 | divided_by: ratio | times: 100 }}%;">
                        <div class="article-card__image-wrapper card__media w-full relative mb-4">
                          <div class="article-card__image overflow-hidden media media--hover-effect" {% if section.settings.media_height == 'adapt' %} style="padding-bottom: {{ 1 | divided_by: article.image.aspect_ratio | times: 100 }}%;"{% endif %}>
                            <img
                              src="${item.thumbnail}"
                              class="motion-reduce relative h-full w-full object-cover"
                            >
                          </div>
                        </div>
                    </div>
                    <div class="card__content md:px-8 px-8 py-4 pb-16  ">
                      <div class="card__information md:text-left">
                        <h3 class="card__heading mb-6  sm:text-lg ">
                          <a href="${item.url}" class="full-unstyled-link">
                            ${item.title}
                          </a>
                        </h3>
                        <div class="article-card__info caption-with-letter-spacing h5 flex flex-wrap">
                          <span class=" text-grayBtn caption-with-letter-spacing text-base font-heading">${item.date}</span>
                        </div>
                        <p class="article-card__excerpt rte-width mt-4">
                          ${item.text_content}
                        </p>
                      </div>
                    </div>
                  </div>
                </div></div>`;
            }

            this.resultsContainter.innerHTML =  html;
          }
          this.articlesContainter.classList.add("hidden");
          this.resultsContainter.classList.remove("hidden");
        }
        debounce(fn, wait) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        }
    }
    customElements.define('search-blogs', SearchBlogs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-carousel"] && !Shopify.designMode) return;
  try {
    
    class FeaturedCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (document.readyState === 'complete') {
          this.init();
        } else {
          window.addEventListener('load', () => this.init());
        }
      };

      init() {
        this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
          // Optional parameters
          direction: 'horizontal',
          loop: false,
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl: '[data-swiper-button-next]',
            prevEl: '[data-swiper-button-prev]',
          },
          speed: 2000,
          breakpoints: {
            768: {
              slidesPerGroup: 1,
              slidesPerView: 1,
            },
            992: {
              slidesPerGroup: 2,
              slidesPerView: 2,
            },
            2000: {
              slidesPerGroup: 3,
              slidesPerView: 3,
            },
            2400: {
              slidesPerGroup: 3,
              slidesPerView: 3,
            },
          }
        });
      }
    }

    customElements.define('featured-carousel', FeaturedCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
    (() => {
      window.addEventListener('load', () => {
        const copyButtons = [...document.querySelectorAll('[data-copy]')];
        copyButtons.forEach(button => {
          button.addEventListener('click', () => {
            navigator.clipboard.writeText(button.textContent)
              .then(() => {
                button.textContent = 'Copied!';
                setTimeout(() => {
                  button.textContent = button.dataset.copy;
                }, 1000);
              })
          })
        });
      })
    }) ();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
    class HeroSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {

						window.addEventListener('load', () => {
                const nav = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                };
                const scope = this;
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: true,
										spaceBetween:0,
										slidesPerView: 1,
                    preloadImages: false,
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 1,
                    },
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    // autoplay: this.dataset.autoplay === 'true' ? true : false,
                    // autoplay: false,
                    autoplay: this.dataset.autoplay === 'true' ? {
                      delay: 15000,                 // Set autoplay interval to 15 seconds
                      disableOnInteraction: false  // Continue autoplay after user interaction
                    } : false,
										speed: Number(this.dataset.speed),
                    navigation: {
                      nextEl: '.swiper-next',
                      prevEl: '.swiper-prev',
                    },
                    on: {
                      init: function () {
                          const slide = scope.querySelector('.swiper-slide-active .hero');
                          if(slide){
                            let navColor = slide.dataset.arrow
                            scope.querySelector('.swiper-next').style.color = navColor;
                            scope.querySelector('.swiper-prev').style.color = navColor;
                          }
                      },
                    },
								});

                this.swiper.on('slideChangeTransitionStart', function () {
                    const slide = scope.querySelector('.swiper-slide-active .hero');
                    let navColor = slide.dataset.arrow
                    scope.querySelector('.swiper-next').style.color = navColor;
                    scope.querySelector('.swiper-prev').style.color = navColor;
                });

						})
				}
    }
    customElements.define('hero-carousel', HeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-carousel"] && !Shopify.designMode) return;
  try {
    
    class PartnerSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {

						window.addEventListener('load', () => {
                const nav = {
                    nextEl: '[data-swiper-button-next]',
                    prevEl: '[data-swiper-button-prev]'
                };
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: true,
										spaceBetween:0,
										slidesPerView: 2,
                    autoplay: this.dataset.autoplay === 'true' ? true : false,
										speed: Number(this.dataset.speed),
										navigation: this.dataset.arrows === 'true' ? nav : false ,
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('partner-carousel', PartnerSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-logos"] && !Shopify.designMode) return;
  try {
    
    class IconSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {
						window.addEventListener('load', () => {
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: false,
										spaceBetween:0,
										slidesPerView: 2,

										speed: Number(this.dataset.speed),
										navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]'
                    },
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-mentioned"] && !Shopify.designMode) return;
  try {
    
  class IconSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      window.addEventListener('load', () => {
        this.swiper = new Swiper(this.querySelector('[data-swiper]'), {

          // Optional parameters
          allowTouchMove: true,
          direction: 'horizontal',
          loop: false,
          spaceBetween: 0,
          slidesPerView: 2,
          speed: Number(this.dataset.speed),
          navigation: {
            nextEl: '[data-swiper-button-next]',
            prevEl: '[data-swiper-button-prev]'
          },
          breakpoints: {
            768: {
              slidesPerGroup: 1,
              slidesPerView: 1
            },
            992: {
              slidesPerGroup: 4,
              slidesPerView: 4
            },
            1280: {
              slidesPerView: Number(this.dataset.slider_slides)
            }
          }
        });
      });
    }
  }
  customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ram-images-with-title"] && !Shopify.designMode) return;
  try {
    
    class IconSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {
						window.addEventListener('load', () => {
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: false,
										spaceBetween:0,
										slidesPerView: 2,

										speed: Number(this.dataset.speed),
										navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]'
                    },
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ram-images"] && !Shopify.designMode) return;
  try {
    
    class IconSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {
						window.addEventListener('load', () => {
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: false,
										spaceBetween:0,
										slidesPerView: 2,

										speed: Number(this.dataset.speed),
										navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]'
                    },
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["short-form-videos"] && !Shopify.designMode) return;
  try {
    
class ShortFormVideos extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.videoCount = parseInt(this.dataset.videoCount) || 1;
  }

  connectedCallback() {
    this.initSwiper();
    this.initPlayButtons();
    this.initNavWidth();
    this.initSlideClick();
    this.initKeyboardNav();
  }

  initSwiper() {
    const swiperEl = this.querySelector('[data-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const prevBtn = this.querySelector('[data-prev]');
    const nextBtn = this.querySelector('[data-next]');
    const progressFill = this.querySelector('[data-progress-fill]');
    const progressTrack = this.querySelector('[data-progress-track]');

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 400,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: 1.25,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 1.35,
          spaceBetween: 32
        }
      },
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn
      },
      on: {
        init: (swiper) => {
          this.updateProgress(swiper, progressFill, progressTrack);
          // Delay to ensure slides are rendered with correct width
          setTimeout(() => this.updateNavWidth(), 50);
        },
        slideChange: (swiper) => {
          this.updateProgress(swiper, progressFill, progressTrack);
          this.pauseAllVideos();
        },
        resize: () => {
          this.updateNavWidth();
        }
      }
    });
  }

  updateProgress(swiper, progressFill, progressTrack) {
    if (!progressFill || !progressTrack) return;

    const currentIndex = swiper.activeIndex + 1;
    const totalSlides = this.videoCount;
    const progressPercent = (currentIndex / totalSlides) * 100;

    progressFill.style.width = `${progressPercent}%`;
    progressTrack.setAttribute('aria-valuenow', currentIndex);
  }

  initNavWidth() {
    this.navControls = this.querySelector('[data-nav-controls]');
    this.updateNavWidth();

    // Update on resize
    this.resizeObserver = new ResizeObserver(() => {
      this.updateNavWidth();
    });
    this.resizeObserver.observe(this);
  }

  updateNavWidth() {
    if (!this.navControls || !this.swiper) return;

    const activeSlide = this.querySelector('.swiper-slide-active');
    if (activeSlide) {
      const slideWidth = activeSlide.offsetWidth;
      this.navControls.style.width = `${slideWidth}px`;
    }
  }

  initSlideClick() {
    const slides = this.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      slide.addEventListener('click', (e) => {
        if (!this.swiper) return;

        const slideIndex = parseInt(slide.dataset.index);
        const activeIndex = this.swiper.activeIndex;

        // Only navigate if clicking on a non-active slide
        if (slideIndex !== activeIndex) {
          // Don't navigate if clicking on a play button or video controls
          if (e.target.closest('[data-play-button]') || e.target.closest('video')) return;

          this.swiper.slideTo(slideIndex);
        }
      });
    });
  }

  initKeyboardNav() {
    this.setAttribute('tabindex', '0');

    this.addEventListener('keydown', (e) => {
      if (!this.swiper) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.swiper.slidePrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.swiper.slideNext();
      }
    });
  }

  initPlayButtons() {
    const playButtons = this.querySelectorAll('[data-play-button]');

    playButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Find elements relative to video-card (parent container)
        const videoCard = button.closest('.video-card');
        if (!videoCard) return;

        const poster = videoCard.querySelector('[data-video-poster]');
        const wrapper = videoCard.querySelector('[data-video-wrapper]');

        // Hide poster and play button
        if (poster) poster.classList.add('hidden');
        button.classList.add('hidden');

        // Mark card as playing to hide title overlay
        videoCard.classList.add('is-playing');

        // Handle Shopify video
        const videoEl = videoCard.querySelector('[data-video-element]');
        if (videoEl) {
          videoEl.play();
          return;
        }

        // Handle YouTube video
        const youtubeContainer = videoCard.querySelector('[data-youtube-container]');
        const youtubeIframe = videoCard.querySelector('[data-youtube-iframe]');

        if (youtubeContainer && youtubeIframe) {
          youtubeContainer.classList.remove('hidden');

          // Load iframe src if not already loaded
          if (!youtubeIframe.src && youtubeIframe.dataset.src) {
            youtubeIframe.src = youtubeIframe.dataset.src;
          }
        }
      });
    });
  }

  pauseAllVideos() {
    // Pause Shopify videos
    const videos = this.querySelectorAll('[data-video-element]');
    videos.forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });

    // Reset YouTube videos by removing src
    const youtubeIframes = this.querySelectorAll('[data-youtube-iframe]');
    youtubeIframes.forEach(iframe => {
      if (iframe.src) {
        const src = iframe.src;
        iframe.src = '';
        iframe.src = src.replace('autoplay=1', 'autoplay=0');
      }
    });

    // Show posters, play buttons, and remove playing state
    const posters = this.querySelectorAll('[data-video-poster].hidden');
    const playButtons = this.querySelectorAll('[data-play-button].hidden');
    const youtubeContainers = this.querySelectorAll('[data-youtube-container]:not(.hidden)');
    const playingCards = this.querySelectorAll('.video-card.is-playing');

    posters.forEach(poster => poster.classList.remove('hidden'));
    playButtons.forEach(btn => btn.classList.remove('hidden'));
    youtubeContainers.forEach(container => container.classList.add('hidden'));
    playingCards.forEach(card => card.classList.remove('is-playing'));
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define('short-form-videos', ShortFormVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
    class Slider extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            window.addEventListener('load', () => {
                this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
                    // Optional parameters
                    autoplay: {
                        delay: Number(this.dataset.speed),
                        disableOnInteraction: false,
                    },
                    direction: 'horizontal',
                    loop: false,
                    navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]',
                    },
                    slidesPerView: "auto",
                    speed: Number(this.dataset.speed)
                });
            })
        }
    }
    customElements.define('testimonial-slider', Slider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
class VideoHero extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.container = this.querySelector('.video-container');
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.observers = []; // Track all observers for cleanup
    this.youtubePlayer = null;
    this.vimeoPlayer = null;
  }

  connectedCallback() {
    this.setupVideoErrorHandling();
    this.setupAccessibility();

    // Respect user's motion preferences
    if (!this.prefersReducedMotion) {
      this.setupAutoplay();
    } else {
      // Pause all videos if user prefers reduced motion
      this.videos.forEach(video => {
        video.pause();
        video.removeAttribute('autoplay');
      });
    }

    this.setupPerformanceOptimizations();
    this.setupSoundControl();
    this.setupProgressBar();
    this.setupScrollAnimations();
    this.setupEmbedPlayers();
  }

  setupVideoErrorHandling() {
    this.videos.forEach(video => {
      video.addEventListener('error', (e) => {
        console.warn('Video failed to load:', e);
        this.container.classList.add('video-error');

        // Announce error to screen readers
        this.announceToScreenReader('Video failed to load. Showing fallback image.');
      });

      video.addEventListener('loadeddata', () => {
        this.container.classList.remove('video-error');
      });
    });
  }

  setupAccessibility() {
    // Add keyboard controls for videos with controls
    this.videos.forEach(video => {
      if (video.hasAttribute('controls')) {
        video.addEventListener('keydown', (e) => {
          // Space bar to play/pause
          if (e.code === 'Space') {
            e.preventDefault();
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          }

          // Arrow keys for seeking
          if (e.code === 'ArrowLeft') {
            e.preventDefault();
            video.currentTime = Math.max(0, video.currentTime - 5);
          }

          if (e.code === 'ArrowRight') {
            e.preventDefault();
            video.currentTime = Math.min(video.duration, video.currentTime + 5);
          }
        });
      }
    });
  }

  setupAutoplay() {
    if (this.dataset.autoplay === 'true') {
      this.videos.forEach(video => {
        // Ensure video autoplays on mobile
        video.setAttribute('playsinline', '');

        // Only mute if explicitly set in settings
        if (video.hasAttribute('muted')) {
          video.setAttribute('muted', '');
        }

        // Handle autoplay when video enters viewport
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const playPromise = video.play();

              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    // Video started successfully
                  })
                  .catch((error) => {
                    console.warn('Autoplay prevented:', error);

                    // If autoplay fails, try muting and playing again
                    video.muted = true;
                    video.play().catch(() => {
                      this.container.classList.add('video-error');
                    });
                  });
              }
            } else if (this.dataset.loop !== 'true') {
              // Pause video when out of viewport (unless looping)
              video.pause();
            }
          });
        }, {
          threshold: 0.25,
          rootMargin: '50px'
        });

        observer.observe(video);
        this.observers.push(observer); // Track for cleanup
      });
    }
  }

  setupSoundControl() {
    const soundButton = this.querySelector('.sound-control-button');
    if (!soundButton) return;

    soundButton.addEventListener('click', () => {
      this.videos.forEach(video => {
        video.muted = !video.muted;
        soundButton.classList.toggle('muted', video.muted);

        // Save preference
        localStorage.setItem('videoHeroMuted', video.muted);
      });
    });

    // Restore user preference
    const savedMutedState = localStorage.getItem('videoHeroMuted');
    if (savedMutedState !== null) {
      const isMuted = savedMutedState === 'true';
      this.videos.forEach(video => {
        video.muted = isMuted;
      });
      soundButton.classList.toggle('muted', isMuted);
    }
  }

  setupProgressBar() {
    const progressBar = this.querySelector('.video-progress-fill');
    if (!progressBar) return;

    this.videos.forEach(video => {
      video.addEventListener('timeupdate', () => {
        if (video.duration) {
          const progress = (video.currentTime / video.duration) * 100;
          progressBar.style.width = `${progress}%`;
        }
      });
    });
  }

  setupScrollAnimations() {
    const textContent = this.querySelector('.text-content[data-scroll-animation="true"]');
    if (!textContent) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('scroll-animate-in')) {
          entry.target.classList.add('scroll-animate-in');
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });

    observer.observe(textContent);
    this.observers.push(observer);
  }

  setupEmbedPlayers() {
    // YouTube Player
    const youtubeContainer = this.querySelector('.youtube-embed');
    if (youtubeContainer) {
      const videoId = youtubeContainer.dataset.videoId;
      if (videoId) {
        this.loadYouTubeAPI(() => {
          this.youtubePlayer = new YT.Player(youtubeContainer.id, {
            videoId: videoId,
            playerVars: {
              autoplay: this.dataset.autoplay === 'true' ? 1 : 0,
              loop: this.dataset.loop === 'true' ? 1 : 0,
              mute: 1,
              controls: 0,
              playsinline: 1,
              rel: 0
            }
          });
        });
      }
    }

    // Vimeo Player
    const vimeoContainer = this.querySelector('.vimeo-embed');
    if (vimeoContainer) {
      const videoId = vimeoContainer.dataset.videoId;
      if (videoId) {
        this.loadVimeoAPI(() => {
          this.vimeoPlayer = new Vimeo.Player(vimeoContainer.id, {
            id: videoId,
            autoplay: this.dataset.autoplay === 'true',
            loop: this.dataset.loop === 'true',
            muted: true,
            controls: false,
            background: true
          });
        });
      }
    }
  }

  loadYouTubeAPI(callback) {
    if (window.YT && window.YT.Player) {
      callback();
    } else {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = callback;
    }
  }

  loadVimeoAPI(callback) {
    if (window.Vimeo && window.Vimeo.Player) {
      callback();
    } else {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.onload = callback;
      document.head.appendChild(script);
    }
  }

  setupPerformanceOptimizations() {
    // Monitor video performance
    this.videos.forEach(video => {
      video.addEventListener('loadstart', () => {
        this.addLoadingIndicator();
      });

      video.addEventListener('canplay', () => {
        this.removeLoadingIndicator();
      });

      // Handle stalled video
      video.addEventListener('stalled', () => {
        console.warn('Video playback stalled');
      });

      // Handle waiting state
      let waitingTimeout;
      video.addEventListener('waiting', () => {
        waitingTimeout = setTimeout(() => {
          this.addLoadingIndicator();
        }, 500);
      });

      video.addEventListener('playing', () => {
        clearTimeout(waitingTimeout);
        this.removeLoadingIndicator();
      });
    });

    // Prefetch poster images on hover (for better UX)
    const buttons = this.querySelectorAll('.hero-button');
    buttons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        // Prefetch the linked page
        const link = button.getAttribute('href');
        if (link && !link.startsWith('#')) {
          const prefetchLink = document.createElement('link');
          prefetchLink.rel = 'prefetch';
          prefetchLink.href = link;
          document.head.appendChild(prefetchLink);
        }
      }, { once: true });
    });
  }

  addLoadingIndicator() {
    if (!this.loadingIndicator) {
      this.loadingIndicator = document.createElement('div');
      this.loadingIndicator.className = 'video-loading';
      this.loadingIndicator.setAttribute('aria-live', 'polite');
      this.loadingIndicator.innerHTML = '<span class="sr-only">Loading video...</span>';
      this.container.appendChild(this.loadingIndicator);
    }
  }

  removeLoadingIndicator() {
    if (this.loadingIndicator) {
      this.loadingIndicator.remove();
      this.loadingIndicator = null;
    }
  }

  announceToScreenReader(message) {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.className = 'sr-only';
    announcement.textContent = message;
    this.appendChild(announcement);

    setTimeout(() => announcement.remove(), 3000);
  }

  disconnectedCallback() {
    // Clean up when component is removed
    this.videos.forEach(video => {
      video.pause();
      video.src = '';
    });

    // Disconnect all observers to prevent memory leaks
    this.observers.forEach(observer => {
      observer.disconnect();
    });
    this.observers = [];

    // Clean up YouTube player
    if (this.youtubePlayer && this.youtubePlayer.destroy) {
      this.youtubePlayer.destroy();
    }

    // Clean up Vimeo player
    if (this.vimeoPlayer && this.vimeoPlayer.destroy) {
      this.vimeoPlayer.destroy();
    }
  }
}

customElements.define('video-hero', VideoHero);

  } catch(e) { console.error(e); }
})();
})();
